if (!window.Maximize.loadedScript.includes('sticky-atc.js')) {
  window.Maximize.loadedScript.push('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('stickyATC', {
        isOpen: false,
        isFooterShow: false,
        isBuyButtonOutOfView: false,
        isOpenDetailOnMobile: false,
        handleInit(sectionId) {
          this.scrollY = window.scrollY;
          const sectionElement = document.querySelector(`.section--${sectionId}`);
          const buyButtonWrapperEle = sectionElement?.querySelector('[data-product-buy-buttons-wrapper]');
          const footerElement = document.getElementById("x-footer");
          const sectionElements = document.querySelectorAll(".x-bundle-section");
          const visibleBundleSections = new Set();

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target.classList.contains('x-bundle-section')) {
                  if (entry.isIntersecting && window.innerWidth < 1023) {
                    visibleBundleSections.add(entry.target);
                  } else {
                    visibleBundleSections.delete(entry.target);
                  }
                } else if (entry.target === buyButtonWrapperEle) {
                  this.isBuyButtonOutOfView = !entry.isIntersecting;
                } else if (entry.target.id === "x-footer") {
                  this.isFooterShow = entry.isIntersecting;
                }
              });
              const isAnySectionVisible = visibleBundleSections.size > 0;
              this.isOpen = !this.isFooterShow && this.isBuyButtonOutOfView && !isAnySectionVisible;
            },
            {root: null, threshold: 0, rootMargin: "0px 0px -10px 0px"}
          );

          if (footerElement) {
            observer.observe(footerElement);
          }
          if (buyButtonWrapperEle) {
            observer.observe(buyButtonWrapperEle);
          }
          sectionElements.forEach(el => {
            if (el) observer.observe(el);
          });
        }
      })

      Alpine.data('xStickyATC', (stickyATCContainerEl, sectionId) => ({
        isOpenDetailOnMobile: false,
        isFirstLoading: true,
        isMobile: window.innerWidth < MIN_DEVICE_WIDTH.desktop,
        availableOptions: [],
        variantOptionsEle: [],
        options: [],
        optionsSelectedValues: [],
        init() {
          this.optionElements = this.$el.querySelectorAll(`#StickyAddToCart__Variant__${sectionId} .variant-option`)
          this.optionsSelectedValues = this.updateOptionSelectedValues();

          const isMobile = window.matchMedia(`(max-width: ${MIN_DEVICE_WIDTH.desktop - 1}px`);

          const handleMediaChange = (e) => {
            if (e.matches) {
              this.isMobile = true;
              if (!this.isFirstLoading) Alpine.store("stickyATC").isOpenDetailOnMobile = true;
            } else {
              this.isMobile = false;
              Alpine.store("stickyATC").isOpenDetailOnMobile = false;
            }
          };

          handleMediaChange(isMobile);
          isMobile.addEventListener('change', handleMediaChange);
          this.isFirstLoading = false;
        },
        selectOptionSticky(event) {
          const targetOption = event.currentTarget;
          let position = targetOption.dataset.optionPosition;

          this.optionsSelectedValues[Number(position) - 1] = targetOption.dataset.optionValueId;

          document.dispatchEvent(new CustomEvent(`${STICKY_ATC_EVENT.optionChange}-${sectionId}`, {
            detail: {
              optionsSelectedValues: this.optionsSelectedValues
            }
          }));
        },
        updateOptionSelectedValues() {
          const newOptionsSelectedValues = [];

          this.optionElements.forEach((optionEle) => {
            const optionPosition = optionEle.dataset.optionPosition;
            const idx = Number(optionPosition) - 1;
            if (optionEle.classList.contains('selected')) {
              newOptionsSelectedValues[idx] = optionEle.dataset.optionValueId;
            }
          });

          return newOptionsSelectedValues;
        }
      }))
    })
  })
}